import React from 'react';
import { bool } from 'prop-types';
import {
  CheckedCircle,
  UncheckedCircle,
} from 'apps/roi/pages/roi-survey/styled-roi-survey';

const CheckboxStatus = ({ active }) =>
  active ? <CheckedCircle /> : <UncheckedCircle />;

CheckboxStatus.propTypes = {
  active: bool,
};

export default CheckboxStatus;
